<div *ngIf="isLobbyLoaded">
    <bgl-slot-races-wrapper [component]="'carousel'" [fromBingoHomepage]="fromBingoHomepage"> </bgl-slot-races-wrapper>
</div>
